import React, { useContext } from "react";
import { StyledPrimaryHeader } from "../../components/styled";
import Context from "../../context/Context";
import Hashtag from "../hashtag";

const SponsorBox = () => {
  const data = useContext(Context);
  const { email, emailSubject, siteName } = data;

  return (
    <div id="becomeasponsor">
      <div className="container">
        <div className="sponsor-left">
          <StyledPrimaryHeader>Become A Sponsor</StyledPrimaryHeader>
          <p>
            Contact us for more information about sponsoring the Google Public
            Sector Forum!
          </p>
        </div>
        <div className="sponsor-right">
          <a
            href={`mailto:${email}${
              emailSubject ? `?subject=${emailSubject}` : ""
            }`}
            className="pdfButton"
            target="_blank"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default SponsorBox;
